import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
  injectSlice,
  appLogout,
} from '@bonanza-social/toolkit/state';
import { InstantWheelState } from './instantWheel.types';
import InstantWheelService from '../services/InstantWheelService/InstantWheelService';

export const fetchSpinsCount = createAsyncThunk(
  'instantWheel/fetchSpinsCount',
  async () => await InstantWheelService.getSpinsCount(),
);

const initialState: InstantWheelState = {
  remainingSpinsCount: {
    data: 0,
    dataState: 'idle',
  },
};

const instantWheel = createSlice({
  name: 'instantWheel',
  initialState,
  reducers: {
    setRemainingSpinsCount(state, { payload }: PayloadAction<number>) {
      state.remainingSpinsCount.data = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSpinsCount.pending, (state) => {
      state.remainingSpinsCount.dataState =
        state.remainingSpinsCount.dataState === 'fulfilled'
          ? 'refreshing'
          : 'pending';
    });

    builder.addCase(fetchSpinsCount.fulfilled, (state, { payload }) => {
      const { remainingSpinsCount } = payload;

      state.remainingSpinsCount.data = remainingSpinsCount;
      state.remainingSpinsCount.dataState = 'fulfilled';
    });

    builder.addCase(fetchSpinsCount.rejected, (state) => {
      state.remainingSpinsCount.dataState = 'rejected';
    });

    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const { setRemainingSpinsCount } = instantWheel.actions;

export const withInstantWheel = injectSlice({
  reducerPath: 'instantWheel',
  reducer: instantWheel.reducer,
});

export const selectRemainingSpinsCount = withInstantWheel.selector(
  (state) => state.instantWheel.remainingSpinsCount.data,
);

export const selectRemainingSpinsCountState = withInstantWheel.selector(
  (state) => state.instantWheel.remainingSpinsCount.dataState,
);

declare global {
  interface LazyLoadedSlices {
    instantWheel: ReturnType<typeof instantWheel.reducer>;
  }
}
